import React from "react";

/**
 * @param {{ stats: Array<{ title: string, value: number|string, icon: string }> }} props
 */
const DashboardStats = ({ stats = [] }) => {
    if (!stats.length) {
        return null;
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-2">
            {stats.map((item, index) => (
                <div
                    key={index}
                    className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all p-1 flex items-center justify-between"
                >
                    {/* Left Content */}
                    <div>
                        <p className="text-[11px]  mb-0.5">
                            {item.title}
                        </p>
                        <p className="text-lg font-semibold text-gray-900 leading-none">
                            {item.value}
                        </p>
                    </div>


                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[rgba(6,78,141,0.08)] text-[var(--base-color)]">
                        <i className={`bi ${item.icon} text-sm`}></i>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DashboardStats;